<template>
	<div
		class="app-count-picker"
		:class="{'app-count-picker--disabled' : $attrs.disabled }"
		@click="open = !open"
		v-on-clickaway="closeOptions"
	>
		<span
			v-if="$attrs.placeholder"
			class="app-count-picker__placeholder"
		>
			{{ `${$attrs.placeholder}:` }}
		</span>

		<div class="app-count-picker__dropdown">
			{{ $attrs.value }}
		</div>

		<div
			class="app-count-picker__arrow"
			:class="{'app-count-picker__arrow--up' : open}"
		/>

		<ul
			v-if="open"
			class="app-count-picker__options"
			:class="{'app-count-picker__options--reverse' : isPullUp()}"
		>
			<li
				v-for="(option, index) in options"
				:key="index"
				class="app-count-picker__option"
				:class="{'app-count-picker__option--selected' : option === $attrs.value}"
				@click.stop="select(option)"
			>
				{{ option }}
			</li>
		</ul>
	</div>
</template>

<script>
export default {
	data () {
		return {
			open: false
		}
	},

	model: {
		prop: 'value',
		event: 'change'
	},

	computed: {
		options () {
			const min = Math.max((Number(this.$attrs.min || 0)), 1)
			const max = Number(this.$attrs.max || 10)
			const step = Number(this.$attrs.step || 1)
			const opt = []
			for (let i = min; i <= max; i += step) opt.push(i)
			return opt
		}
	},

	methods: {
		isPullUp () {
			const elementPosition = this.$el.getBoundingClientRect().top
			return window.innerHeight - elementPosition < elementPosition
		},

		select (option) {
			this.open = false
			this.$emit('change', option)
		},

		closeOptions () {
			this.open = false
		}
	}

}
</script>

<style lang="scss" scoped>
.app-count-picker {
	padding: 5px 8px;
	border: 1px solid $default-light;
	background-color: #fff;
	font-size: 1em;
	font-family: inherit;
	user-select: none;
	border-radius: 3px;
	display: inline-flex;
	align-items: center;
	position: relative;
	cursor: pointer;
	color: $default;

	&--disabled {
		pointer-events: none;
		opacity: 0.5;
	}

	&__dropdown {
		flex: 1 1 auto;
		text-align: center;
		padding: 0 10px;
	}

	&__options {
		border-radius: 3px;
		list-style: none;
		background-color: #fff;
		border: 1px solid $default-light;
		position: absolute;
		top: 100%;
		left: 0;
		min-width: 100%;
		margin: 5px 0;
		height: auto;
		max-height: 100px;
		overflow-y: auto;

		&--reverse {
			top: auto;
			bottom: 100%;
		}
	}

	&__option {
		text-align: center;
		padding: 2px 8px;

		&--selected {
			color: $primary;
			pointer-events: none;
		}

		&:hover,
		&:hover &--selected {
			background-color: $primary;
			color: #fff;
		}
	}

	&__arrow {
		flex-grow: 0;
		width: .5em;
		height: .5em;
		border: solid $default-light;
		border-width: 0 .1em .1em 0;
		transform: rotate(45deg);
		pointer-events: none;

		&--up {
			margin-bottom: 0;
			transform: rotate(-135deg);
		}
	}

	&:hover,
	&:hover &__options {
		border-color: $primary;
	}
}
</style>
